import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Custom hook to fetch and filter loan officers data
 * 
 * @param {string} branchNmlsId - The branch NMLS ID to filter officers by (optional)
 * @returns {Object} - Object containing filtered officers data, loading state, and error state
 */
const useOfficersData = (branchNmlsId = null) => {
  const [officers, setOfficers] = useState([]);
  const [filteredOfficers, setFilteredOfficers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOfficersData = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get("https://d3ew7tynzn2izn.cloudfront.net/includes/allmlodata.json");
        
        // Process the data
        const processedData = processOfficersData(response.data);
        setOfficers(processedData);
        
        // Filter by branch NMLS ID if provided
        if (branchNmlsId) {
          const filtered = processedData.filter(officer => 
            officer.branchNmls === branchNmlsId
          );
          setFilteredOfficers(filtered);
        } else {
          setFilteredOfficers(processedData);
        }
        
        setError(null);
      } catch (err) {
        console.error('Error fetching officers data:', err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOfficersData();
  }, [branchNmlsId]);

  // Helper function to process officers data
  const processOfficersData = (data) => {
    // Handle empty branch NMLS
    const dataWithBranchNmls = data.map(ele => {
      if (ele.branchNmls === "") {
        return {
          ...ele,
          branchNmls: '3277'
        };
      } else {
        return ele;
      }
    });

    // Handle state information
    return dataWithBranchNmls.map(ele => {
      let state = " ";
      let stateCode = "";
      
      if (ele.address && ele.address.length >= 8) {
        stateCode = ele.address.substring(ele.address.length - 8, ele.address.length - 6);
        // For demonstration purposes - in real code, you'd use actual state data
        state = stateCode;
      }
      
      return {
        ...ele,
        state: state
      };
    });
  };

  return { officers, filteredOfficers, isLoading, error };
};

export default useOfficersData;